
export default function RateTable() {
  const services = [
    {
      name: 'Timber Inventory & Stand Mapping (RGB)',
      low: 6,
      high: 12,
      turnaround: '5–7 days',
      description: 'Stand boundaries, density, species mix, access routes',
    },
    {
      name: 'Forest Health & Stress Analysis (Multispectral)',
      low: 12,
      high: 25,
      turnaround: '7–10 days',
      description: 'Disease, pest pressure, drought stress, die-off detection',
    },
    {
      name: 'LiDAR Forestry Survey',
      low: 30,
      high: 75,
      turnaround: '10–14 days',
      description: 'Canopy height, terrain modeling, volume estimates, biomass',
    },
    {
      name: 'Pre-Acquisition & Valuation Survey',
      low: 15,
      high: 30,
      turnaround: '7–10 days',
      description: 'Independent data for buyers, sellers, and investment funds',
    },
    {
      name: 'Post-Storm & Insurance Assessment',
      low: 10,
      high: 25,
      turnaround: '3–5 days',
      description: 'Rapid damage documentation, loss quantification, claims support',
    },
  ];

  return (
    <section id="rate-table" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-stone-900 mb-4">
            Service Rate Overview
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Base per-acre rates at standard scale (500+ acres). Smaller parcels
            carry a scaling premium.
          </p>
        </div>

        <div className="bg-stone-50 rounded-xl border border-stone-200 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-stone-100">
                  <th className="text-left px-6 py-4 font-semibold text-stone-900">
                    Service
                  </th>
                  <th className="text-right px-6 py-4 font-semibold text-stone-900">
                    Base Rate
                  </th>
                  <th className="text-right px-6 py-4 font-semibold text-stone-900">
                    Turnaround
                  </th>
                </tr>
              </thead>
              <tbody>
                {services.map((service, index) => (
                  <tr key={index} className="border-t border-stone-200">
                    <td className="px-6 py-5">
                      <div className="font-semibold text-stone-900">
                        {service.name}
                      </div>
                      <div className="text-xs text-stone-500 mt-1">
                        {service.description}
                      </div>
                    </td>
                    <td className="px-6 py-5 text-right">
                      <span className="font-bold text-amber-700">
                        ${service.low}–${service.high}
                      </span>
                      <span className="text-stone-500 text-xs block">
                        /acre
                      </span>
                    </td>
                    <td className="px-6 py-5 text-right text-stone-600">
                      {service.turnaround}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Scaling note */}
        <div className="mt-8 grid md:grid-cols-3 gap-6">
          <div className="bg-amber-50 rounded-lg p-5 border border-amber-200">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-up-line text-amber-600"></i>
              </span>
              <span className="font-semibold text-stone-900 text-sm">
                Small Parcels (&lt;500 ac)
              </span>
            </div>
            <p className="text-xs text-stone-600 leading-relaxed">
              Up to 1.6x multiplier at 25 acres. Fixed costs like mobilization
              and flight planning don&apos;t scale linearly with small acreage.
            </p>
          </div>

          <div className="bg-stone-50 rounded-lg p-5 border border-stone-200">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-checkbox-circle-line text-stone-600"></i>
              </span>
              <span className="font-semibold text-stone-900 text-sm">
                Standard Scale (500+ ac)
              </span>
            </div>
            <p className="text-xs text-stone-600 leading-relaxed">
              Base rates apply at 500 acres and above. Economies of scale keep
              per-acre costs predictable.
            </p>
          </div>

          <div className="bg-stone-50 rounded-lg p-5 border border-stone-200">
            <div className="flex items-center gap-2 mb-2">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-repeat-line text-stone-600"></i>
              </span>
              <span className="font-semibold text-stone-900 text-sm">
                Recurring Discounts
              </span>
            </div>
            <p className="text-xs text-stone-600 leading-relaxed">
              Annual surveys save 10%. Semi-annual surveys save 15%. Retainer
              clients get the best rates.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
